/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {SettlementDetailInformationConfigurationModel} from '../services/settlement-detail-configuration/models/settlement-detail-information-configuration.model';
import {StatusTimelineConfigurationModel} from '../../shared/status-timeline/models/status-timeline-configuration.model';
import {HistoryStateConfigurationModel} from '../../shared/status-timeline/models/history-state-configuration.model';
import {StateConfigurationModel} from '../../shared/status-timeline/models/state-configuration.model';
import {StatefulComponent} from '../../shared/stateful/stateful.component';
import {settlementTimelineHappyPath} from '../services/settlement-detail-configuration/configuration/settlement-timeline-happypath-configuration';
import {SettlementStatusEnum} from '../models/settlement-status.enum';
import {statusTimelineConfiguration} from './configuration/settlement-timeline-status-configuration';

@Component({
    selector: 'app-settlement-detail-information',
    templateUrl: './settlement-detail-information.component.html',
    styleUrls: ['./settlement-detail-information.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementDetailInformationComponent
        extends StatefulComponent<SettlementStatusEnum>
        implements OnInit {

    @Input() configuration: SettlementDetailInformationConfigurationModel;

    private statusHistoryConfiguration: ReadonlyMap<SettlementStatusEnum, HistoryStateConfigurationModel[]>;
    private happyPathConfiguration: ReadonlyMap<SettlementStatusEnum, StateConfigurationModel[]>;

    ngOnInit(): void {
        const statusConfiguration = new Map<SettlementStatusEnum, HistoryStateConfigurationModel>([
            [
                SettlementStatusEnum.CREATION, {
                state: statusTimelineConfiguration.creation
                }
            ],
            [

                SettlementStatusEnum.PENDING, {
                state: statusTimelineConfiguration.pending,
                timestamp: this.configuration?.lastPendingDate
                }
            ],
            [
                SettlementStatusEnum.ACCEPTED, {
                state: statusTimelineConfiguration.accepted,
                timestamp: this.configuration?.lastChangeDateTime
                }
            ],
            [
                SettlementStatusEnum.REJECTED, {
                state: statusTimelineConfiguration.rejected,
                timestamp: this.configuration?.lastChangeDateTime
                }
            ]

        ]);

        this.statusHistoryConfiguration = new Map<SettlementStatusEnum, HistoryStateConfigurationModel[]>([
            [
                SettlementStatusEnum.PENDING, [
                statusConfiguration.get(SettlementStatusEnum.CREATION),
                statusConfiguration.get(SettlementStatusEnum.PENDING)
            ]
            ],
            [
                SettlementStatusEnum.ACCEPTED, [
                statusConfiguration.get(SettlementStatusEnum.CREATION),
                statusConfiguration.get(SettlementStatusEnum.PENDING),
                statusConfiguration.get(SettlementStatusEnum.ACCEPTED)
            ]
            ],
            [
                SettlementStatusEnum.REJECTED, [
                statusConfiguration.get(SettlementStatusEnum.CREATION),
                statusConfiguration.get(SettlementStatusEnum.PENDING),
                statusConfiguration.get(SettlementStatusEnum.REJECTED)
            ]
            ]
        ]);

        this.happyPathConfiguration = new Map<SettlementStatusEnum, StateConfigurationModel[]>([
            [SettlementStatusEnum.PENDING, [settlementTimelineHappyPath.unknown]],
            [SettlementStatusEnum.ACCEPTED, [settlementTimelineHappyPath.pending, settlementTimelineHappyPath.accepted]],
            [SettlementStatusEnum.REJECTED, [settlementTimelineHappyPath.pending, settlementTimelineHappyPath.rejected]]
        ]);
    }

    mapStatusTimelineToConfigurationModel(): StatusTimelineConfigurationModel {
        const configuration: StatusTimelineConfigurationModel = {
            backgroundColor: '#f6f6f6',
            happyPath: this.happyPathConfiguration.get(this.configuration?.status),
            statusHistory: this.statusHistoryConfiguration.get(this.configuration?.status),
            collapseAtLevel: 1,
            hasCollapsibleButton: true
        };

        return configuration;
    }
}
